import React from 'react';
import { Link } from 'react-router-dom';

/*
 * Su smartphone la testata tiene solo il logo, la campanella e l'account: «Supporto clienti» (Whatsapp e Ticket) passa in fondo
 * al menu principale. Sopra i 768px questo blocco non si vede (la testata ha già i due tasti).
 */
export const WHATSAPP_HREF = `https://wa.me/393925364267?text=${encodeURIComponent('Ciao, ho bisogno di assistenza su SportID')}`;

const SupportoNelMenu = ({ tipo = 'struttura' }) => (
    <div className="sid-supporto-menu">
        <div className="sid-supporto-menu__titolo">Supporto clienti</div>
        <a className="sid-supporto-menu__voce" href={WHATSAPP_HREF} target="_blank" rel="noopener noreferrer">Whatsapp</a>
        <Link className="sid-supporto-menu__voce" to={`/${tipo}/ticket`}>Ticket</Link>
    </div>
);

export default SupportoNelMenu;
